import * as globals from "./globals";
import type { OctopusTheme } from "./OctopusTheme";
export const darkTheme: OctopusTheme = {
    "colorAvatarBackgroundImageDefault": globals["colorScales"]["navy"]["300"],
    "colorAvatarBackgroundImageHover": globals["colorScales"]["navy"]["400"],
    "colorAvatarBackgroundProjectDefault": globals["colorScales"]["navy"]["600"],
    "colorAvatarBackgroundProjectHover": globals["colorScales"]["navy"]["700"],
    "colorAvatarBackgroundSpaceDefault": globals["colorScales"]["blue"]["600"],
    "colorAvatarBackgroundSpaceHover": globals["colorScales"]["blue"]["700"],
    "colorAvatarBackgroundTemplateDefault": globals["colorScales"]["navy"]["200"],
    "colorAvatarBackgroundTemplateHover": globals["colorScales"]["navy"]["300"],
    "colorAvatarBackgroundTenantDefault": globals["colorScales"]["white"],
    "colorAvatarBackgroundTenantHover": globals["colorScales"]["navy"]["100"],
    "colorAvatarBackgroundUserDefault": globals["colorScales"]["blue"]["600"],
    "colorAvatarBackgroundUserHover": globals["colorScales"]["blue"]["700"],
    "colorAvatarIconPrimary": globals["colorScales"]["white"],
    "colorAvatarIconSecondary": globals["colorScales"]["navy"]["800"],
    "colorAvatarStackBackgroundHover": globals["colorScales"]["blue"]["800"],
    "colorAvatarStackBorder": globals["colorScales"]["navy"]["900"],
    "colorAvatarText": globals["colorScales"]["white"],
    "colorBackgroundBold": globals["colorScales"]["black"],
    "colorBackgroundDanger": globals["colorScales"]["red"]["700"],
    "colorBackgroundDisabled": globals["colorScales"]["navy"]["700"],
    "colorBackgroundFeature": globals["colorScales"]["purple"]["700"],
    "colorBackgroundInfo": globals["colorScales"]["blue"]["700"],
    "colorBackgroundInverseNeutral": globals["colorScales"]["slate"]["400"],
    "colorBackgroundInversePrimary": globals["colorScales"]["white"],
    "colorBackgroundInverseSecondary": globals["colorScales"]["navy"]["300"],
    "colorBackgroundInverseSuccess": globals["colorScales"]["green"]["400"],
    "colorBackgroundPrimaryDefault": globals["colorScales"]["navy"]["900"],
    "colorBackgroundPrimaryHover": globals["colorScales"]["navy"]["800"],
    "colorBackgroundPrimaryPressed": globals["colorScales"]["navy"]["700"],
    "colorBackgroundPrimaryTransparent": "rgb(from #111A23 r g b / 0.52)",
    "colorBackgroundQuartaryDefault": globals["colorScales"]["navy"]["800"],
    "colorBackgroundQuartaryHover": globals["colorScales"]["navy"]["700"],
    "colorBackgroundQuartaryPressed": globals["colorScales"]["navy"]["900"],
    "colorBackgroundSecondaryDefault": globals["colorScales"]["navy"]["800"],
    "colorBackgroundSecondaryHover": globals["colorScales"]["navy"]["700"],
    "colorBackgroundSecondaryPressed": globals["colorScales"]["navy"]["900"],
    "colorBackgroundSecondaryTransparent": "rgb(from #1F303F r g b / 0.52)",
    "colorBackgroundSelected": globals["colorScales"]["blue"]["400"],
    "colorBackgroundSuccess": globals["colorScales"]["green"]["700"],
    "colorBackgroundTertiary": globals["colorScales"]["navy"]["700"],
    "colorBackgroundWarning": globals["colorScales"]["yellow"]["600"],
    "colorBadgeBackgroundDanger": globals["colorScales"]["red"]["500"],
    "colorBadgeBackgroundFeature": globals["colorScales"]["purple"]["300"],
    "colorBadgeBackgroundInfo": globals["colorScales"]["blue"]["500"],
    "colorBadgeBackgroundInverseNeutral": globals["colorScales"]["slate"]["700"],
    "colorBadgeBackgroundNeutral": globals["colorScales"]["slate"]["400"],
    "colorBadgeBackgroundSuccess": globals["colorScales"]["green"]["500"],
    "colorBadgeBackgroundUpsell": globals["colorScales"]["purple"]["300"],
    "colorBadgeBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorBadgeIconFeature": globals["colorScales"]["purple"]["800"],
    "colorBadgeIconPrimary": globals["colorScales"]["white"],
    "colorBadgeIconSecondary": globals["colorScales"]["black"],
    "colorBadgeIconUpsell": globals["colorScales"]["purple"]["800"],
    "colorBadgeTextFeature": globals["colorScales"]["purple"]["800"],
    "colorBadgeTextPrimary": globals["colorScales"]["white"],
    "colorBadgeTextSecondary": globals["colorScales"]["black"],
    "colorBadgeTextUpsell": globals["colorScales"]["purple"]["800"],
    "colorBorderBold": globals["colorScales"]["navy"]["400"],
    "colorBorderDanger": globals["colorScales"]["red"]["400"],
    "colorBorderDefault": globals["colorScales"]["navy"]["500"],
    "colorBorderDisabled": globals["colorScales"]["navy"]["600"],
    "colorBorderFeature": globals["colorScales"]["purple"]["400"],
    "colorBorderInfo": globals["colorScales"]["blue"]["400"],
    "colorBorderInversePrimary": globals["colorScales"]["navy"]["200"],
    "colorBorderInverseSecondary": globals["colorScales"]["navy"]["100"],
    "colorBorderLinkDefault": globals["colorScales"]["blue"]["300"],
    "colorBorderLinkHover": globals["colorScales"]["blue"]["400"],
    "colorBorderPrimary": globals["colorScales"]["navy"]["700"],
    "colorBorderSecondary": globals["colorScales"]["navy"]["800"],
    "colorBorderSelected": globals["colorScales"]["blue"]["400"],
    "colorBorderSuccess": globals["colorScales"]["green"]["400"],
    "colorBorderTertiary": globals["colorScales"]["navy"]["600"],
    "colorBorderWarning": globals["colorScales"]["yellow"]["300"],
    "colorButtonBackgroundDestructiveDefault": globals["colorScales"]["red"]["500"],
    "colorButtonBackgroundDestructiveHover": globals["colorScales"]["red"]["600"],
    "colorButtonBackgroundDestructivePressed": globals["colorScales"]["red"]["700"],
    "colorButtonBackgroundDisabled": "rgb(from #1F303F r g b / 0.56)",
    "colorButtonBackgroundLoudDefault": globals["colorScales"]["blue"]["500"],
    "colorButtonBackgroundLoudHover": globals["colorScales"]["blue"]["600"],
    "colorButtonBackgroundLoudPressed": globals["colorScales"]["blue"]["700"],
    "colorButtonBackgroundNeutralDefault": globals["colorScales"]["navy"]["900"],
    "colorButtonBackgroundNeutralHover": globals["colorScales"]["navy"]["700"],
    "colorButtonBackgroundNeutralPressed": globals["colorScales"]["navy"]["600"],
    "colorButtonBackgroundPrimaryDefault": globals["colorScales"]["green"]["500"],
    "colorButtonBackgroundPrimaryHover": globals["colorScales"]["green"]["600"],
    "colorButtonBackgroundPrimaryPressed": globals["colorScales"]["green"]["700"],
    "colorButtonBackgroundQuietDefault": "rgb(from #1A77CA r g b / 0.01)",
    "colorButtonBackgroundQuietHover": "rgb(from #1A77CA r g b / 0.16)",
    "colorButtonBackgroundQuietPressed": "rgb(from #1A77CA r g b / 0.32)",
    "colorButtonBackgroundSecondaryDefault": "rgb(from #1A77CA r g b / 0.01)",
    "colorButtonBackgroundSecondaryHover": "rgb(from #1A77CA r g b / 0.16)",
    "colorButtonBackgroundSecondaryPressed": "rgb(from #1A77CA r g b / 0.32)",
    "colorButtonBackgroundTertiaryDefault": "rgb(from #1A77CA r g b / 0.24)",
    "colorButtonBackgroundTertiaryHover": "rgb(from #1A77CA r g b / 0.32)",
    "colorButtonBackgroundTertiaryPressed": "rgb(from #1A77CA r g b / 0.4)",
    "colorButtonBorderDisabled": globals["colorScales"]["navy"]["700"],
    "colorButtonBorderSecondary": globals["colorScales"]["blue"]["500"],
    "colorButtonIconDestructive": globals["colorScales"]["white"],
    "colorButtonIconDisabled": globals["colorScales"]["navy"]["600"],
    "colorButtonIconLoud": globals["colorScales"]["white"],
    "colorButtonIconNeutral": globals["colorScales"]["navy"]["100"],
    "colorButtonIconPrimary": globals["colorScales"]["white"],
    "colorButtonIconQuiet": globals["colorScales"]["blue"]["400"],
    "colorButtonIconSecondary": globals["colorScales"]["blue"]["400"],
    "colorButtonIconTertiary": globals["colorScales"]["blue"]["400"],
    "colorButtonTextDestructive": globals["colorScales"]["white"],
    "colorButtonTextDisabled": globals["colorScales"]["navy"]["600"],
    "colorButtonTextLoud": globals["colorScales"]["white"],
    "colorButtonTextNeutral": globals["colorScales"]["navy"]["100"],
    "colorButtonTextPrimary": globals["colorScales"]["white"],
    "colorButtonTextQuiet": globals["colorScales"]["blue"]["400"],
    "colorButtonTextSecondary": globals["colorScales"]["blue"]["400"],
    "colorButtonTextTertiary": globals["colorScales"]["blue"]["400"],
    "colorCalloutBackgroundDangerDefault": "rgb(from #AA3030 r g b / 0.54)",
    "colorCalloutBackgroundDangerHover": "rgb(from #AA3030 r g b / 0.48)",
    "colorCalloutBackgroundDangerPressed": "rgb(from #AA3030 r g b / 0.32)",
    "colorCalloutBackgroundDefaultHover": "rgb(from #3E607D r g b / 0.48)",
    "colorCalloutBackgroundDefaultPressed": "rgb(from #3E607D r g b / 0.32)",
    "colorCalloutBackgroundFeatureDefault": "rgb(from #7043B7 r g b / 0.54)",
    "colorCalloutBackgroundFeatureHover": "rgb(from #7043B7 r g b / 0.48)",
    "colorCalloutBackgroundFeaturePressed": "rgb(from #7043B7 r g b / 0.32)",
    "colorCalloutBackgroundInfoDefault": "rgb(from #155EA0 r g b / 0.54)",
    "colorCalloutBackgroundInfoHover": "rgb(from #155EA0 r g b / 0.48)",
    "colorCalloutBackgroundInfoPressed": "rgb(from #155EA0 r g b / 0.32)",
    "colorCalloutBackgroundSuccessDefault": "rgb(from #006A3D r g b / 0.54)",
    "colorCalloutBackgroundSuccessHover": "rgb(from #006A3D r g b / 0.48)",
    "colorCalloutBackgroundSuccessPressed": "rgb(from #006A3D r g b / 0.32)",
    "colorCalloutBackgroundUpsell": "linear-gradient(95deg, rgb(from #0F4778 r g b / 0.4) 0%, rgb(from #572B97 r g b / 0.4) 100%)",
    "colorCalloutBackgroundWarningDefault": "rgb(from #745801 r g b / 0.62)",
    "colorCalloutBackgroundWarningHover": "rgb(from #745801 r g b / 0.56)",
    "colorCalloutBackgroundWarningPressed": "rgb(from #745801 r g b / 0.4)",
    "colorCalloutBorderDanger": globals["colorScales"]["red"]["400"],
    "colorCalloutBorderDefault": globals["colorScales"]["navy"]["500"],
    "colorCalloutBorderFeature": globals["colorScales"]["purple"]["400"],
    "colorCalloutBorderInfo": globals["colorScales"]["blue"]["400"],
    "colorCalloutBorderSuccess": globals["colorScales"]["green"]["400"],
    "colorCalloutBorderUpsell": "linear-gradient(180deg, #1A77CA 0%, #895ED3 100%)",
    "colorCalloutBorderWarning": globals["colorScales"]["yellow"]["400"],
    "colorCalloutIconDanger": globals["colorScales"]["red"]["300"],
    "colorCalloutIconDefault": globals["colorScales"]["navy"]["300"],
    "colorCalloutIconFeature": globals["colorScales"]["purple"]["300"],
    "colorCalloutIconInfo": globals["colorScales"]["blue"]["300"],
    "colorCalloutIconSuccess": globals["colorScales"]["green"]["300"],
    "colorCalloutIconWarning": globals["colorScales"]["yellow"]["200"],
    "colorCalloutTextBody": globals["colorScales"]["white"],
    "colorCalloutTextDanger": globals["colorScales"]["red"]["300"],
    "colorCalloutTextDefault": globals["colorScales"]["navy"]["300"],
    "colorCalloutTextFeature": globals["colorScales"]["purple"]["300"],
    "colorCalloutTextInfo": globals["colorScales"]["blue"]["300"],
    "colorCalloutTextSuccess": globals["colorScales"]["green"]["300"],
    "colorCalloutTextWarning": globals["colorScales"]["yellow"]["200"],
    "colorCardBackgroundPrimaryDefault": globals["colorScales"]["navy"]["800"],
    "colorCardBackgroundSecondaryDefault": "rgb(from #111A23 r g b / 0)",
    "colorCardBackgroundSecondaryHover": "rgb(from #282F38 r g b / 0.64)",
    "colorCarouselBackgroundPrimary": globals["colorScales"]["navy"]["900"],
    "colorCarouselIconDefault": "rgb(from #A9BBCB r g b / 0.32)",
    "colorCarouselIconHover": "rgb(from #A9BBCB r g b / 0.72)",
    "colorCarouselIconSelected": globals["colorScales"]["blue"]["400"],
    "colorCarouselTextPrimary": globals["colorScales"]["white"],
    "colorCategorySelectListBackgroundActive": "rgb(from #1A77CA r g b / 0.24)",
    "colorCategorySelectListBackgroundDefault": globals["colorScales"]["navy"]["800"],
    "colorCategorySelectListBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListIconActive": globals["colorScales"]["blue"]["400"],
    "colorCategorySelectListIconDefault": globals["colorScales"]["slate"]["300"],
    "colorCategorySelectListIconHover": globals["colorScales"]["white"],
    "colorCategorySelectListTextActive": globals["colorScales"]["blue"]["400"],
    "colorCategorySelectListTextHover": globals["colorScales"]["white"],
    "colorChipBackgroundDanger": globals["colorScales"]["red"]["500"],
    "colorChipBackgroundPrimary": globals["colorScales"]["navy"]["700"],
    "colorChipBackgroundSecondary": globals["colorScales"]["blue"]["600"],
    "colorChipBackgroundSuccessful": globals["colorScales"]["green"]["500"],
    "colorChipBorderPrimary": globals["colorScales"]["slate"]["600"],
    "colorChipFilledBackgroundDanger": globals["colorScales"]["red"]["700"],
    "colorChipFilledBackgroundInfo": globals["colorScales"]["blue"]["700"],
    "colorChipFilledBackgroundPrimary": globals["colorScales"]["navy"]["700"],
    "colorChipFilledBackgroundSecondary": globals["colorScales"]["purple"]["700"],
    "colorChipFilledBackgroundSuccess": globals["colorScales"]["green"]["700"],
    "colorChipFilledBackgroundWarning": globals["colorScales"]["yellow"]["700"],
    "colorChipFilledIconDanger": globals["colorScales"]["red"]["200"],
    "colorChipFilledIconInfo": globals["colorScales"]["blue"]["200"],
    "colorChipFilledIconPrimary": globals["colorScales"]["navy"]["200"],
    "colorChipFilledIconSecondary": globals["colorScales"]["purple"]["200"],
    "colorChipFilledIconSuccess": globals["colorScales"]["green"]["200"],
    "colorChipFilledIconWarning": globals["colorScales"]["yellow"]["200"],
    "colorChipFilledTextDanger": globals["colorScales"]["red"]["200"],
    "colorChipFilledTextInfo": globals["colorScales"]["blue"]["200"],
    "colorChipFilledTextPrimary": globals["colorScales"]["navy"]["200"],
    "colorChipFilledTextSecondary": globals["colorScales"]["purple"]["200"],
    "colorChipFilledTextSuccess": globals["colorScales"]["green"]["200"],
    "colorChipFilledTextWarning": globals["colorScales"]["yellow"]["200"],
    "colorChipIconInverse": globals["colorScales"]["white"],
    "colorChipIconPrimary": globals["colorScales"]["white"],
    "colorChipIconWarning": globals["colorScales"]["orange"]["500"],
    "colorChipOutlinedBorderDanger": globals["colorScales"]["red"]["400"],
    "colorChipOutlinedBorderInfo": globals["colorScales"]["blue"]["400"],
    "colorChipOutlinedBorderPrimary": globals["colorScales"]["navy"]["400"],
    "colorChipOutlinedBorderSecondary": globals["colorScales"]["purple"]["400"],
    "colorChipOutlinedBorderSuccess": globals["colorScales"]["green"]["400"],
    "colorChipOutlinedBorderWarning": globals["colorScales"]["yellow"]["400"],
    "colorChipOutlinedIconDanger": globals["colorScales"]["red"]["400"],
    "colorChipOutlinedIconInfo": globals["colorScales"]["blue"]["400"],
    "colorChipOutlinedIconPrimary": globals["colorScales"]["navy"]["400"],
    "colorChipOutlinedIconSecondary": globals["colorScales"]["purple"]["400"],
    "colorChipOutlinedIconSuccess": globals["colorScales"]["green"]["400"],
    "colorChipOutlinedIconWarning": globals["colorScales"]["yellow"]["400"],
    "colorChipOutlinedTextDanger": globals["colorScales"]["red"]["400"],
    "colorChipOutlinedTextInfo": globals["colorScales"]["blue"]["400"],
    "colorChipOutlinedTextPrimary": globals["colorScales"]["navy"]["400"],
    "colorChipOutlinedTextSecondary": globals["colorScales"]["purple"]["400"],
    "colorChipOutlinedTextSuccess": globals["colorScales"]["green"]["400"],
    "colorChipOutlinedTextWarning": globals["colorScales"]["yellow"]["400"],
    "colorChipTextInverse": globals["colorScales"]["navy"]["800"],
    "colorChipTextPrimary": globals["colorScales"]["white"],
    "colorCodeEditorBackground": globals["colorScales"]["navy"]["900"],
    "colorCodeEditorCodeActivelineBackground": "rgb(from #7C98B4 r g b / 0.15)",
    "colorCodeEditorCodeAtomNumberKeywordVariableAttributeQuoteColor": globals["colorScales"]["blue"]["400"],
    "colorCodeEditorCodeBracketCommentColor": globals["colorScales"]["grey"]["400"],
    "colorCodeEditorCodeCursorBorderLeft": globals["colorScales"]["navy"]["300"],
    "colorCodeEditorCodeCursorBorderRight": globals["colorScales"]["navy"]["300"],
    "colorCodeEditorCodeDefTagBuiltinQualifierHeaderEmColor": globals["colorScales"]["red"]["300"],
    "colorCodeEditorCodeErrorInvalidcharColor": globals["colorScales"]["red"]["400"],
    "colorCodeEditorCodeFatCursorBackground": globals["colorScales"]["navy"]["300"],
    "colorCodeEditorCodeHint": globals["colorScales"]["navy"]["100"],
    "colorCodeEditorCodeHintActiveBackground": globals["colorScales"]["navy"]["800"],
    "colorCodeEditorCodeHintsBackground": globals["colorScales"]["navy"]["800"],
    "colorCodeEditorCodeIndentationMarkerActiveColor": globals["colorScales"]["navy"]["600"],
    "colorCodeEditorCodeIndentationMarkerColor": globals["colorScales"]["navy"]["800"],
    "colorCodeEditorCodeLinenumberColor": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeMatchingbracketColor": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodePositiveColor": globals["colorScales"]["green"]["400"],
    "colorCodeEditorCodePropertyColor": globals["colorScales"]["orange"]["300"],
    "colorCodeEditorCodePunctuationUnitNegativeColor": globals["colorScales"]["red"]["200"],
    "colorCodeEditorCodeSelectedBackground": globals["colorScales"]["navy"]["800"],
    "colorCodeEditorCodeStringOperatorColor": globals["colorScales"]["green"]["300"],
    "colorCodeEditorCodeSyntaxAtom": globals["colorScales"]["orange"]["300"],
    "colorCodeEditorCodeSyntaxAttributeName": globals["colorScales"]["blue"]["300"],
    "colorCodeEditorCodeSyntaxBool": globals["colorScales"]["orange"]["300"],
    "colorCodeEditorCodeSyntaxBracket": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeSyntaxClassName": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorCodeSyntaxComment": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeSyntaxDeleted": globals["colorScales"]["red"]["200"],
    "colorCodeEditorCodeSyntaxDeletedBackground": globals["colorScales"]["red"]["100"],
    "colorCodeEditorCodeSyntaxEmphasis": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorCodeSyntaxEscape": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxHeading": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorCodeSyntaxInvalid": globals["colorScales"]["red"]["400"],
    "colorCodeEditorCodeSyntaxKeyword": globals["colorScales"]["red"]["300"],
    "colorCodeEditorCodeSyntaxLink": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxMeta": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxName": globals["colorScales"]["green"]["300"],
    "colorCodeEditorCodeSyntaxNumber": globals["colorScales"]["blue"]["300"],
    "colorCodeEditorCodeSyntaxOperator": globals["colorScales"]["blue"]["300"],
    "colorCodeEditorCodeSyntaxPropertyName": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorCodeSyntaxQuote": globals["colorScales"]["green"]["300"],
    "colorCodeEditorCodeSyntaxRegexp": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxSpecialVariableName": globals["colorScales"]["orange"]["300"],
    "colorCodeEditorCodeSyntaxString": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxStrong": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorCodeSyntaxTagName": globals["colorScales"]["green"]["300"],
    "colorCodeEditorCodeSyntaxTypeName": globals["colorScales"]["red"]["300"],
    "colorCodeEditorCodeSyntaxTypeOperator": globals["colorScales"]["red"]["300"],
    "colorCodeEditorCodeSyntaxUrl": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxVariableName": globals["colorScales"]["blue"]["300"],
    "colorCodeEditorCodeVariable2Variable3String2UrlColor": globals["colorScales"]["blue"]["300"],
    "colorCodeEditorCodeVariableColor": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorForeground": globals["colorScales"]["navy"]["200"],
    "colorCodeEditorSelection": globals["colorScales"]["blue"]["700"],
    "colorCodeEditorSelectionMatch": globals["colorScales"]["blue"]["700"],
    "colorCodeEditorTextDefault": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorTextGutter": globals["colorScales"]["navy"]["400"],
    "colorCodeEditorTextHighlight": globals["colorScales"]["orange"]["200"],
    "colorCodeEditorTextHintHighlight": globals["colorScales"]["green"]["200"],
    "colorCodeEditorToolbarBackground": globals["colorScales"]["navy"]["800"],
    "colorCodeEditorToolbarButtonHover": globals["colorScales"]["navy"]["900"],
    "colorCodeReviewBackgroundDangerDefault": globals["colorScales"]["red"]["800"],
    "colorCodeReviewBackgroundDangerMuted": globals["colorScales"]["red"]["700"],
    "colorCodeReviewBackgroundPrimaryDefault": globals["colorScales"]["navy"]["900"],
    "colorCodeReviewBackgroundPrimaryMuted": globals["colorScales"]["navy"]["800"],
    "colorCodeReviewBackgroundSuccessDefault": globals["colorScales"]["green"]["800"],
    "colorCodeReviewBackgroundSuccessMuted": globals["colorScales"]["green"]["700"],
    "colorCodeReviewTextDanger": globals["colorScales"]["red"]["300"],
    "colorCodeReviewTextPrimary": globals["colorScales"]["navy"]["100"],
    "colorCodeReviewTextSuccess": globals["colorScales"]["green"]["300"],
    "colorDeprecatedBackgroundWarning": globals["colorScales"]["orange"]["700"],
    "colorDeprecatedBorderWarning": globals["colorScales"]["orange"]["400"],
    "colorDeprecatedIconWarning": globals["colorScales"]["orange"]["400"],
    "colorDeprecatedTextWarning": globals["colorScales"]["orange"]["300"],
    "colorDialogBackgroundPrimary": globals["colorScales"]["navy"]["800"],
    "colorDialogBackgroundSecondaryDefault": globals["colorScales"]["navy"]["700"],
    "colorDialogBackgroundSecondaryUpsell": "linear-gradient(95deg, rgb(from #1A77CA r g b / 0.6) 0%, rgb(from #895ED3 r g b / 0.6) 100%)",
    "colorDialogHelpPanelText": globals["colorScales"]["white"],
    "colorHealthStatusBackgroundExecuting": globals["colorScales"]["blue"]["600"],
    "colorHealthStatusBackgroundFailure": globals["colorScales"]["red"]["600"],
    "colorHealthStatusBackgroundNeutral": globals["colorScales"]["slate"]["600"],
    "colorHealthStatusBackgroundSuccess": globals["colorScales"]["green"]["600"],
    "colorHealthStatusBackgroundWarning": globals["colorScales"]["yellow"]["600"],
    "colorHealthStatusIconDefault": globals["colorScales"]["white"],
    "colorHealthStatusIconInverse": globals["colorScales"]["slate"]["100"],
    "colorIconDanger": globals["colorScales"]["red"]["400"],
    "colorIconDisabled": globals["colorScales"]["navy"]["600"],
    "colorIconFeature": globals["colorScales"]["purple"]["400"],
    "colorIconInfo": globals["colorScales"]["blue"]["400"],
    "colorIconInversePrimary": globals["colorScales"]["navy"]["900"],
    "colorIconInverseSecondary": globals["colorScales"]["navy"]["800"],
    "colorIconLinkDefault": globals["colorScales"]["blue"]["300"],
    "colorIconLinkHover": globals["colorScales"]["blue"]["400"],
    "colorIconPrimary": globals["colorScales"]["navy"]["100"],
    "colorIconSecondary": globals["colorScales"]["navy"]["300"],
    "colorIconSelected": globals["colorScales"]["blue"]["300"],
    "colorIconSuccess": globals["colorScales"]["green"]["400"],
    "colorIconTertiary": globals["colorScales"]["navy"]["400"],
    "colorIconWarning": globals["colorScales"]["yellow"]["300"],
    "colorLifecycleBackgroundPrimary": globals["colorScales"]["navy"]["500"],
    "colorLifecycleBorderDefault": globals["colorScales"]["navy"]["300"],
    "colorLifecycleIconPrimary": globals["colorScales"]["white"],
    "colorLifecycleTextPrimary": globals["colorScales"]["navy"]["100"],
    "colorMenuListBackgroundActive": globals["colorScales"]["navy"]["600"],
    "colorMenuListBackgroundDefault": globals["colorScales"]["navy"]["800"],
    "colorMenuListBackgroundHover": globals["colorScales"]["navy"]["700"],
    "colorMenuListBorderPrimary": globals["colorScales"]["navy"]["600"],
    "colorMenuListIconPrimary": globals["colorScales"]["navy"]["400"],
    "colorMenuListTextHighlight": globals["colorScales"]["blue"]["400"],
    "colorMenuListTextPrimary": globals["colorScales"]["navy"]["100"],
    "colorMenuListTextSecondary": globals["colorScales"]["navy"]["200"],
    "colorNavButtonBackgroundActive": globals["colorScales"]["blue"]["500"],
    "colorNavButtonBackgroundDefault": "rgb(from #1A77CA r g b / 0.01)",
    "colorNavButtonBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorNavButtonBackgroundPressed": globals["colorScales"]["blue"]["600"],
    "colorNavButtonIconActive": globals["colorScales"]["white"],
    "colorNavButtonIconDefault": globals["colorScales"]["white"],
    "colorNavButtonIconHover": globals["colorScales"]["white"],
    "colorNavButtonIconPressed": globals["colorScales"]["white"],
    "colorNavListBackgroundActive": "rgb(from #2E475D r g b / 0.7)",
    "colorNavListBackgroundDefault": "rgb(from #1A77CA r g b / 0)",
    "colorNavListBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorNavListIconActive": globals["colorScales"]["blue"]["400"],
    "colorNavListIconDefault": globals["colorScales"]["navy"]["500"],
    "colorNavListTextActive": globals["colorScales"]["blue"]["400"],
    "colorNavListTextDefault": globals["colorScales"]["navy"]["100"],
    "colorNavListTextHover": globals["colorScales"]["white"],
    "colorNavTabBackgroundActive": "rgb(from #FFFFFF r g b / 0)",
    "colorNavTabBackgroundHover": globals["colorScales"]["navy"]["700"],
    "colorNavTabBorderPrimary": globals["colorScales"]["blue"]["400"],
    "colorNavTabIconActive": globals["colorScales"]["blue"]["300"],
    "colorNavTabIconDefault": globals["colorScales"]["white"],
    "colorNavTabIconHover": globals["colorScales"]["white"],
    "colorNavTabTextActive": globals["colorScales"]["blue"]["300"],
    "colorNavTabTextDefault": globals["colorScales"]["white"],
    "colorNavTabTextHover": globals["colorScales"]["white"],
    "colorOverlayPrimary": "rgb(from #111A23 r g b / 0.56)",
    "colorOverlaySecondary": "rgb(from #000000 r g b / 0.31)",
    "colorPaginationBackgroundActive": globals["colorScales"]["blue"]["400"],
    "colorPaginationBackgroundDefault": globals["colorScales"]["navy"]["900"],
    "colorPaginationBackgroundDisabled": globals["colorScales"]["navy"]["900"],
    "colorPaginationBackgroundHover": globals["colorScales"]["navy"]["500"],
    "colorPaginationIconActive": globals["colorScales"]["navy"]["900"],
    "colorPaginationIconDefault": globals["colorScales"]["navy"]["100"],
    "colorPaginationIconDisabled": globals["colorScales"]["navy"]["600"],
    "colorPaginationIconHover": globals["colorScales"]["white"],
    "colorPaginationTextActive": globals["colorScales"]["navy"]["900"],
    "colorPaginationTextDefault": globals["colorScales"]["navy"]["100"],
    "colorPaginationTextDisabled": globals["colorScales"]["navy"]["600"],
    "colorPaginationTextHover": globals["colorScales"]["white"],
    "colorParallelChipBackground": globals["colorScales"]["blue"]["500"],
    "colorParallelChipIcon": globals["colorScales"]["white"],
    "colorPopoverBackgroundPrimary": globals["colorScales"]["navy"]["900"],
    "colorPopoverBackgroundSecondary": globals["colorScales"]["navy"]["800"],
    "colorPopoverInfoCircleBackgroundDefault": globals["colorScales"]["blue"]["300"],
    "colorPopoverInfoCircleBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorPopoverInfoCircleTextDefault": globals["colorScales"]["blue"]["700"],
    "colorPopoverInfoCircleTextHover": globals["colorScales"]["white"],
    "colorPortalCardBackground": globals["colorScales"]["navy"]["700"],
    "colorPortalCardContentDisabled": globals["colorScales"]["navy"]["300"],
    "colorPortalCardContentText": globals["colorScales"]["navy"]["200"],
    "colorPortalChipBackground": globals["colorScales"]["navy"]["700"],
    "colorPortalLinkTextHover": globals["colorScales"]["white"],
    "colorPortalLogoBackground": globals["colorScales"]["blue"]["100"],
    "colorPortalPopoverBackground": globals["colorScales"]["navy"]["700"],
    "colorProcessContainerBackgroundSelected": globals["colorScales"]["navy"]["700"],
    "colorProcessContainerBorderSelected": globals["colorScales"]["navy"]["600"],
    "colorProcessStepBackgroundErrorPrimary": globals["colorScales"]["red"]["800"],
    "colorProcessStepBackgroundErrorSecondary": globals["colorScales"]["red"]["600"],
    "colorProcessStepBackgroundErrorSelected": globals["colorScales"]["red"]["700"],
    "colorProcessStepBackgroundHoverError": globals["colorScales"]["red"]["700"],
    "colorProcessStepBackgroundHoverPrimary": globals["colorScales"]["navy"]["800"],
    "colorProcessStepBackgroundHoverSecondary": globals["colorScales"]["navy"]["700"],
    "colorProcessStepBackgroundHoverTertiary": globals["colorScales"]["navy"]["800"],
    "colorProcessStepBackgroundHoverWarning": globals["colorScales"]["orange"]["500"],
    "colorProcessStepBackgroundPrimaryDefault": globals["colorScales"]["navy"]["900"],
    "colorProcessStepBackgroundPrimarySelected": globals["colorScales"]["navy"]["600"],
    "colorProcessStepBackgroundSecondaryDefault": globals["colorScales"]["navy"]["800"],
    "colorProcessStepBackgroundWarningDefault": globals["colorScales"]["orange"]["600"],
    "colorProcessStepBackgroundWarningSecondary": globals["colorScales"]["orange"]["400"],
    "colorProcessStepBackgroundWarningSelected": globals["colorScales"]["orange"]["500"],
    "colorProcessStepBorderDefault": globals["colorScales"]["navy"]["700"],
    "colorProcessStepBorderDisabled": globals["colorScales"]["navy"]["700"],
    "colorProcessStepBorderErrorDefault": globals["colorScales"]["red"]["700"],
    "colorProcessStepBorderErrorHover": globals["colorScales"]["red"]["600"],
    "colorProcessStepBorderErrorSelected": globals["colorScales"]["red"]["500"],
    "colorProcessStepBorderHover": globals["colorScales"]["navy"]["600"],
    "colorProcessStepBorderSelected": globals["colorScales"]["navy"]["500"],
    "colorProcessStepBorderWarningDefault": globals["colorScales"]["orange"]["500"],
    "colorProcessStepBorderWarningHover": globals["colorScales"]["orange"]["400"],
    "colorProcessStepBorderWarningSelected": globals["colorScales"]["orange"]["300"],
    "colorProcessStepIconDefault": globals["colorScales"]["blue"]["200"],
    "colorProcessStepIconErrorPrimary": globals["colorScales"]["red"]["400"],
    "colorProcessStepIconErrorSecondary": globals["colorScales"]["red"]["300"],
    "colorProcessStepIconWarningPrimary": globals["colorScales"]["orange"]["300"],
    "colorProcessStepIconWarningSecondary": globals["colorScales"]["orange"]["200"],
    "colorProcessStepTextDisabled": globals["colorScales"]["navy"]["400"],
    "colorProcessWrapperBackgroundPrimary": globals["colorScales"]["navy"]["900"],
    "colorProcessWrapperBackgroundSecondary": globals["colorScales"]["navy"]["800"],
    "colorProgressBackgroundLinear": globals["colorScales"]["blue"]["300"],
    "colorProgressBackgroundPrimary": globals["colorScales"]["blue"]["300"],
    "colorProgressBackgroundSecondary": globals["colorScales"]["blue"]["600"],
    "colorProgressForegroundCircular": globals["colorScales"]["blue"]["500"],
    "colorProgressForegroundLinear": globals["colorScales"]["blue"]["600"],
    "colorProgressTextInfo": globals["colorScales"]["blue"]["400"],
    "colorScrollbarBackground": "rgb(from #111A23 r g b / 0)",
    "colorScrollbarHandle": globals["colorScales"]["navy"]["500"],
    "colorSpaceSwitcherBackgroundDefault": "rgb(from #2E475D r g b / 0.64)",
    "colorSpaceSwitcherBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorSpaceSwitcherBackgroundPressed": globals["colorScales"]["blue"]["500"],
    "colorSpaceSwitcherBorderPrimary": "rgb(from #000000 r g b / 0.16)",
    "colorSpaceSwitcherIconDefault": globals["colorScales"]["navy"]["300"],
    "colorSpaceSwitcherTextDefault": globals["colorScales"]["navy"]["300"],
    "colorSpaceSwitcherTextHover": globals["colorScales"]["white"],
    "colorSpaceSwitcherTextPressed": globals["colorScales"]["white"],
    "colorStatusBadgeBackgroundHealthy": globals["colorScales"]["green"]["600"],
    "colorStatusBadgeBackgroundNeutral": globals["colorScales"]["slate"]["600"],
    "colorStatusBadgeBackgroundUnhealthy": globals["colorScales"]["red"]["600"],
    "colorStatusBadgeBackgroundWarning": globals["colorScales"]["yellow"]["600"],
    "colorStatusBadgeIconDefault": globals["colorScales"]["white"],
    "colorStatusBadgeIconInverse": globals["colorScales"]["slate"]["100"],
    "colorStatusBadgeTextInverse": globals["colorScales"]["slate"]["100"],
    "colorStatusBadgeTextPrimary": globals["colorScales"]["navy"]["100"],
    "colorSwitchBackgroundOffDefault": globals["colorScales"]["navy"]["500"],
    "colorSwitchBackgroundOffDisabled": globals["colorScales"]["navy"]["700"],
    "colorSwitchBackgroundOnDefault": globals["colorScales"]["blue"]["200"],
    "colorSwitchBackgroundOnDisabled": globals["colorScales"]["blue"]["600"],
    "colorSwitchForegroundOffDefault": globals["colorScales"]["navy"]["300"],
    "colorSwitchForegroundOffDisabled": globals["colorScales"]["navy"]["600"],
    "colorSwitchForegroundOnDefault": globals["colorScales"]["blue"]["400"],
    "colorSwitchForegroundOnDisabled": globals["colorScales"]["blue"]["700"],
    "colorSwitchIconActive": globals["colorScales"]["blue"]["400"],
    "colorSwitchOverlayOff": "rgb(from #557999 r g b / 0.16)",
    "colorSwitchOverlayOn": "rgb(from #CDE4F7 r g b / 0.16)",
    "colorTagBackgroundDefault": globals["colorScales"]["navy"]["700"],
    "colorTagBackgroundHover": globals["colorScales"]["navy"]["800"],
    "colorTextDanger": globals["colorScales"]["red"]["300"],
    "colorTextDisabled": globals["colorScales"]["navy"]["600"],
    "colorTextFeature": globals["colorScales"]["purple"]["300"],
    "colorTextFieldBorderActive": globals["colorScales"]["blue"]["400"],
    "colorTextFieldBorderDanger": globals["colorScales"]["red"]["400"],
    "colorTextFieldBorderDefault": globals["colorScales"]["navy"]["700"],
    "colorTextFieldBorderDisabled": globals["colorScales"]["navy"]["700"],
    "colorTextFieldBorderHover": globals["colorScales"]["navy"]["500"],
    "colorTextFieldIconDisabled": globals["colorScales"]["navy"]["600"],
    "colorTextFieldIconPrimary": globals["colorScales"]["navy"]["200"],
    "colorTextFieldTextDanger": globals["colorScales"]["red"]["400"],
    "colorTextFieldTextDisabled": globals["colorScales"]["navy"]["600"],
    "colorTextFieldTextPrimary": globals["colorScales"]["navy"]["100"],
    "colorTextFieldTextSecondary": globals["colorScales"]["navy"]["300"],
    "colorTextFieldTextSelected": globals["colorScales"]["blue"]["400"],
    "colorTextInfo": globals["colorScales"]["blue"]["300"],
    "colorTextInversePrimary": globals["colorScales"]["navy"]["900"],
    "colorTextInverseSecondary": globals["colorScales"]["navy"]["800"],
    "colorTextLinkDefault": globals["colorScales"]["blue"]["300"],
    "colorTextLinkHover": globals["colorScales"]["blue"]["400"],
    "colorTextPrimary": globals["colorScales"]["navy"]["100"],
    "colorTextSecondary": globals["colorScales"]["navy"]["300"],
    "colorTextSelected": globals["colorScales"]["blue"]["400"],
    "colorTextSuccess": globals["colorScales"]["green"]["300"],
    "colorTextTertiary": globals["colorScales"]["navy"]["400"],
    "colorTextWarning": globals["colorScales"]["yellow"]["200"],
    "shadowDrawer": "-4px 0 16px 0 rgba(0,0,0,0.16), -12px 4px 24px -4px rgba(0,0,0,0.32)",
    "shadowExtraSmall": "0 1px 8px 0 rgba(0,0,0,0.12), 0 1px 2px 0 rgba(0,0,0,0.06)",
    "shadowFocused": "0 0 0 1px rgb(68,155,225), 0 0 0 5px rgba(68,155,225,0.4)",
    "shadowFocusedInset": "inset 0 0 0 4px rgba(68,155,225,0.4)",
    "shadowLarge": "0 2px 6px 0 rgba(0,0,0,0.26), 0 24px 32px -4px rgba(0,0,0,0.42)",
    "shadowLayoutPrimary": "-2px -2px 16px 0 rgba(0,0,0,0.06)",
    "shadowMedium": "0 0 4px 0 rgba(0,0,0,0.24), 0 6px 12px 0 rgba(0,0,0,0.30)",
    "shadowSmall": "0 1px 1px 0 rgba(0,0,0,0.16), 0 1px 8px 0 rgba(0,0,0,0.16)"
};